import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "./styles";
import TimButton from "@vendors/CreativeTim/components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

export const Button = React.forwardRef(
  ({ progress, outlined, color, ...props }, ref) => {
    const classes = useStyles();
    const disabled = props.disabled || progress;

    const buttonClass = classnames({
      [classes.outlined]: outlined,
      [`outline-${color || "default"}`]: outlined,
    });

    return (
      <div className={classes.wrapper}>
        <TimButton
          ref={ref}
          {...props}
          color={color}
          disabled={disabled}
          className={buttonClass}
        />
        {progress && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    );
  }
);

Button.propTypes = {
  ...TimButton.propTypes,
  progress: PropTypes.bool,
  outlined: PropTypes.bool,
};

export default Button;
